<template>
  <section class="price-package" id="price">
    <div class="container">
      <h2 class="wow fadeInUp">Cenník</h2>
      <p class="subtitle wow fadeInUp" data-wow-delay="0.1s">Transparentné ceny pre každého</p>
      <div class="price-img-wrap wow fadeInUp" data-wow-delay="0.2s">
        <img src="@/assets/images/c.webp" alt="Cenník Diamond Gym" />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "PriceSection",
}
</script>

<style scoped>
.price-package {
  background-color: #0a0a0a;
  border-top: 2px solid #E8B923;
  border-bottom: 2px solid #E8B923;
  text-align: center;
}

.price-package h2 {
  font-size: clamp(26px, 4vw, 36px);
  color: #E8B923;
  margin-bottom: 10px;
}

.price-package h2::after {
  content: '';
  display: block;
  width: 56px;
  height: 3px;
  background: #E8B923;
  border-radius: 2px;
  margin: 12px auto 0;
}

.subtitle {
  font-size: 15px;
  color: #888;
  margin-bottom: 40px;
}

.price-img-wrap {
  max-width: 720px;
  margin: 0 auto;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 32px rgba(232, 185, 35, 0.15);
  transition: box-shadow 0.3s ease, transform 0.3s ease;
}

.price-img-wrap:hover {
  transform: scale(1.01);
  box-shadow: 0 8px 40px rgba(232, 185, 35, 0.25);
}

.price-img-wrap img {
  width: 100%;
  height: auto;
  display: block;
}
</style>
